(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
$(document).ready(function(){
  $(document).on('click','.myfilter',function(){
    $('.collection__filter').slideToggle();
  });
      if($(window).width() < 768){
        var filtermob = $('.collection__filter').addClass('mob');
        if($(filtermob).hasClass('mob')){
          $('.collection__filter').show();
         $('.collection__filter').each(function () {
           var $this = $(this);
    if (!$(this).text().match(/^\s*$/)) {
        $(this).insertBefore($(this).prev('.collection__sort'));
    }
});
        }
       }
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lookbook"]) return;
  try {
    
    $(document).ready(function(){
      $(document).on('click', '.sw_variant', function(e){
        e.preventDefault();
        var vid = $(this).data('variant-id');
        addItemToCart(vid);
      });

      $(document).on('click', '.view_products', function(e){
        e.preventDefault();

        $(this).parents('.look-image').find('.look-overlay').toggleClass('look-overlay_show');
      });

       $(".main-big-image").hover(function () {
       if($(window).width() > 769){
                    $(this).find('.look-overlay').css('opacity', 1);
       }
                }, function () {
       if($(window).width() > 769){
                    $(this).find('.look-overlay').css('opacity',0);
       }
      }); 

      $(document).on('click', '.close_btn', function (e) {
        e.preventDefault();
        if($(window).width() < 767){
        $(this).parents('.look-image').find('.look-overlay').removeClass('look-overlay_show');
        }
        else{
        $(this).parents('.look-image').find('.look-overlay').css('opacity',0);
          
        }
        
     });
      
    });

    function addItemToCart(variant_id) {
      data = {
        "id": variant_id,
        "quantity": 1
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
          window.location.href = '/cart';
        }
      });
    }

  } catch(e) { console.error(e); }
})();
})();
